import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import toast from "react-hot-toast";
import Breadcrumbs from "../../components/Breadcrumbs";
import { getAccountTypesByAgreement } from "../../api/Agreement";
import { getBillingGroupsByAgreement } from "../../api/BillingGroups";
import { getUserDevicesByAgreement, createUserDevice } from "../../api/Agreement";
import DeviceForm from "../../components/userDevice/DeviceForm";

const CreateUserDevicePage = () => {
  const { agreementPublicId } = useParams();
  const [selected, setSelected] = useState([]);
  const { getAccessToken } = useAuth();

  const [accountTypes, setAccountTypes] = useState([]);
  const [accountTypesLoaded, setAccountTypesLoaded] = useState(false);
  const [billingGroups, setBillingGroups] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [devices, setDevices] = useState([]);
  const [devicesLoaded, setDevicesLoaded] = useState(false);
  const [device, setDevice] = useState({
    displayName: "",
    productUrl: "",
    agreementPublicId: agreementPublicId || "",
  });
  const [originalDevice, setOriginalDevice] = useState(device);

  const navigate = useNavigate();
  const onChange = (updated) => {
    setSelected(updated);
  };

  const deviceNames = devices.map((device) => device.displayName);

  useEffect(() => {
    fetchDevices();
  }, [agreementPublicId]);
  
  useEffect(() => {
    if (device && originalDevice) {
      const isEqual = JSON.stringify(device) === JSON.stringify(originalDevice);
      setHasChanges(!isEqual);
    }
  }, [device, originalDevice]);

  const fetchDevices = async () => {
    try {
      const accessToken = await getAccessToken();
      const agreementDevices = await getUserDevicesByAgreement(agreementPublicId, accessToken);

      setDevices(agreementDevices);
      setDevicesLoaded(true);
    } catch (error) {
      console.error("Failed to fetch devices:", error);
      setDevicesLoaded(true);
    }
  };

  const handleCreateUserDevice = async () => {
    try {
      const accessToken = await getAccessToken();
      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      const payload = {
        agreementPublicId: device.agreementPublicId,
        displayName: device.displayName,
        productUrl: device.productUrl,
      };
      console.log("User device CREATED:", payload);

      await createUserDevice(payload, accessToken);

      toast.success("User device created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });
    } catch (error) {
      console.error("Failed to create user Device:", error);
      toast.error("Failed to create user device");
    }
    navigate(-1);
  };

  const toggleSelection = (option) => {
    const updated = selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [...selected, option];
    onChange(updated);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create user device</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBackClick}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!hasChanges}
                  onClick={handleCreateUserDevice}
                >
                  Save user device
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <DeviceForm
                device={device}
                setDevice={setDevice}
                setHasChanges={setHasChanges}
                devices={devices}
                devicesLoaded={devicesLoaded}
                selected={selected}
                onChange={onChange}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateUserDevicePage;

